module.exports = __webpack_public_path__ + "i18n/nl.0e8e2822ec20c5a459cb1ca762dddd7c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1289
// module chunks = 60